import React from "react";

const CrossIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18.24"
      height="18.219"
      viewBox="0 0 18.24 18.219"
    >
      <path
        id="fld_ic"
        d="M28.094,12.975a9.12,9.12,0,0,0-6.453,15.572,9.216,9.216,0,0,0,6.453,2.646,9.363,9.363,0,0,0,6.453-2.646,9.12,9.12,0,0,0-6.453-15.572Zm-3.473,4.819a.89.89,0,0,1,.578.247l2.9,2.9,2.9-2.9a.8.8,0,0,1,1.158,0,.8.8,0,0,1,0,1.158l-2.9,2.9,2.9,2.9a.819.819,0,0,1-1.158,1.158l-2.9-2.9L25.2,26.23a.819.819,0,0,1-1.158-1.158l2.9-2.9-2.9-2.977a.8.8,0,0,1,0-1.158A.894.894,0,0,1,24.621,17.794Z"
        transform="translate(-18.974 -12.975)"
        fill={fill ? fill : "#0051bc"}
      />
    </svg>
  );
};

export default CrossIcon;
